import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Send, Bot } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";

export default function AgentPage() {
  const { id } = useParams();
  const [agent, setAgent] = useState(null);
  const [err, setErr] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const sid = useRef("s-" + Math.random().toString(36).slice(2, 8));
  const scroller = useRef(null);

  useEffect(() => {
    api.getAgent(id).then((a) => { setAgent(a); if (a.greeting) setMsgs([{ role: "assistant", content: a.greeting }]); }).catch(() => setErr(true));
  }, [id]);
  useEffect(() => { scroller.current?.scrollTo({ top: 9e9, behavior: "smooth" }); }, [msgs, loading]);

  const send = async () => {
    if (!input.trim() || loading) return;
    const t = input.trim(); setInput(""); setMsgs((m) => [...m, { role: "user", content: t }]); setLoading(true);
    try { const r = await api.agentChat(id, { message: t, session_id: sid.current }); setMsgs((m) => [...m, { role: "assistant", content: r.content }]); }
    catch (e) { setMsgs((m) => [...m, { role: "assistant", content: "تعذّر الرد حاليًا." }]); }
    setLoading(false);
  };

  if (err) return <div className="flex min-h-screen items-center justify-center text-muted-foreground">الوكيل غير موجود.</div>;
  if (!agent) return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-cyan" /></div>;

  return (
    <main className="relative min-h-screen pt-28">
      <div className="absolute left-1/2 top-20 h-64 w-[700px] -translate-x-1/2 hero-glow blur-3xl" />
      <section className="relative mx-auto max-w-3xl px-5 lg:px-8">
        <div className="flex items-center gap-3">
          <span className="flex h-12 w-12 items-center justify-center rounded-2xl brand-gradient text-[#052027]"><Bot className="h-6 w-6" /></span>
          <div><h1 className="font-display text-2xl font-extrabold text-white">{agent.name}</h1><p className="text-xs text-cyan">وكيل ذكاء AQL4 · مباشر</p></div>
        </div>

        <div className="mt-6 flex h-[64vh] flex-col rounded-2xl border border-white/10 bg-white/[0.02]">
          <div ref={scroller} className="flex-1 space-y-3 overflow-y-auto p-4">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-start" : "justify-end"}`}>
                <div className={`max-w-[85%] whitespace-pre-wrap rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${m.role === "user" ? "bg-white/5 text-white" : "border border-cyan/20 bg-cyan/5 text-cyan-50"}`}>{m.content}</div>
              </div>
            ))}
            {loading && <div className="flex justify-end"><div className="rounded-2xl border border-cyan/20 bg-cyan/5 px-4 py-2.5"><Loader2 className="h-4 w-4 animate-spin text-cyan" /></div></div>}
          </div>
          <div className="flex gap-2 border-t border-white/5 p-3">
            <Textarea value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }} rows={2} placeholder="اكتب رسالتك…" className="resize-none border-white/10 bg-white/5 text-right text-white" />
            <Button onClick={send} disabled={loading} className="btn-cyan h-auto rounded-xl px-4 hover:bg-transparent">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}</Button>
          </div>
        </div>
      </section>
      <div className="h-16" />
    </main>
  );
}
